import Vue from 'vue'
import Home from './Home.vue'

import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)
import { DatePicker, Select, Option } from 'element-ui'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)

Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)

Vue.config.productionTip = false

new Vue({
  render: h => h(Home)
}).$mount('#app')
